import _defineProperty from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getGlobalObject, getNumberOfUrlSegments, logger } from '@sentry/utils';
import hoistNonReactStatics from 'hoist-non-react-statics';
import React__default from 'react';
var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx";
var activeTransaction;

var _useEffect;

var _useLocation;

var _useNavigationType;

var _createRoutesFromChildren;

var _matchRoutes;

var _customStartTransaction;

var _startTransactionOnLocationChange;

var global = getGlobalObject();
var SENTRY_TAGS = {
  'routing.instrumentation': 'react-router-v6'
};

function reactRouterV6Instrumentation(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes) {
  return function (customStartTransaction) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var initPathName = global && global.location && global.location.pathname;

    if (startTransactionOnPageLoad && initPathName) {
      activeTransaction = customStartTransaction({
        name: initPathName,
        op: 'pageload',
        tags: SENTRY_TAGS,
        metadata: {
          source: 'url'
        }
      });
    }

    _useEffect = useEffect;
    _useLocation = useLocation;
    _useNavigationType = useNavigationType;
    _matchRoutes = matchRoutes;
    _createRoutesFromChildren = createRoutesFromChildren;
    _customStartTransaction = customStartTransaction;
    _startTransactionOnLocationChange = startTransactionOnLocationChange;
  };
}

function getNormalizedName(routes, location, matchRoutes) {
  if (!routes || routes.length === 0 || !matchRoutes) {
    return [location.pathname, 'url'];
  }

  var branches = matchRoutes(routes, location);
  var pathBuilder = '';

  if (branches) {
    for (var x = 0; x < branches.length; x++) {
      var branch = branches[x];
      var route = branch.route;

      if (route) {
        // Early return if index route
        if (route.index) {
          return [branch.pathname, 'route'];
        }

        var path = route.path;

        if (path) {
          var newPath = path[0] === '/' ? path : "/".concat(path);
          pathBuilder += newPath;

          if (branch.pathname === location.pathname) {
            // If the route defined on the element is something like
            // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
            // We should check against the branch.pathname for the number of / seperators
            if (getNumberOfUrlSegments(pathBuilder) !== getNumberOfUrlSegments(branch.pathname)) {
              return [newPath, 'route'];
            }

            return [pathBuilder, 'route'];
          }
        }
      }
    }
  }

  return [location.pathname, 'url'];
}

function withSentryReactRouterV6Routing(Routes) {
  var _this = this;

  if (!_useEffect || !_useLocation || !_useNavigationType || !_createRoutesFromChildren || !_matchRoutes || !_customStartTransaction) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.');
    return Routes;
  }

  var isBaseLocation = false;
  var routes;

  var SentryRoutes = function SentryRoutes(props) {
    var location = _useLocation();

    var navigationType = _useNavigationType();

    _useEffect(function () {
      // Performance concern:
      // This is repeated when <Routes /> is rendered.
      routes = _createRoutesFromChildren(props.children);
      isBaseLocation = true;

      if (activeTransaction) {
        var _getNormalizedName = getNormalizedName(routes, location, _matchRoutes),
            _getNormalizedName2 = _slicedToArray(_getNormalizedName, 2),
            name = _getNormalizedName2[0],
            source = _getNormalizedName2[1];

        activeTransaction.setName(name);
        activeTransaction.setMetadata({
          source: source
        });
      }
    }, [props.children]);

    _useEffect(function () {
      if (isBaseLocation) {
        if (activeTransaction) {
          activeTransaction.finish();
        }

        return;
      }

      if (_startTransactionOnLocationChange && (navigationType === 'PUSH' || navigationType === 'POP')) {
        if (activeTransaction) {
          activeTransaction.finish();
        }

        var _getNormalizedName3 = getNormalizedName(routes, location, _matchRoutes),
            _getNormalizedName4 = _slicedToArray(_getNormalizedName3, 2),
            name = _getNormalizedName4[0],
            source = _getNormalizedName4[1];

        activeTransaction = _customStartTransaction({
          name: name,
          op: 'navigation',
          tags: SENTRY_TAGS,
          metadata: {
            source: source
          }
        });
      }
    }, [props.children, location, navigationType, isBaseLocation]);

    isBaseLocation = false; // @ts-ignore Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params

    return React__default.createElement(Routes, _objectSpread(_objectSpread({}, props), {}, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 211
      }
    }));
  };

  hoistNonReactStatics(SentryRoutes, Routes); // @ts-ignore Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params

  return SentryRoutes;
}

export { reactRouterV6Instrumentation, withSentryReactRouterV6Routing };